'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _otherForm = require('./other-form.html');

var _otherForm2 = _interopRequireDefault(_otherForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _otherForm2.default,
  bindings: {
    adverseEvent: '<',
    locked: '<'
  },
  controller: function OtherFormComponent() {
    'ngInject';

    _classCallCheck(this, OtherFormComponent);
  }
};


// WEBPACK FOOTER //
// ./components/app/adverse-event/other-form/other-form.component.js